import React from 'react'
import { useTranslation } from 'react-i18next'
import type { PropertyTagsProps } from './PropertyTags.types'
import {
  PropertyTagsContainer,
  PropertyTag,
  AddTagButton,
  PlusIcon,
  TagsWrapper,
  PrimaryIndicator,
  EmptyStateContainer,
} from './PropertyTags.styles'

export const PropertyTags: React.FC<PropertyTagsProps> = ({
  tags,
  loading,
  error,
  onEditClick,
}) => {
  const { t } = useTranslation('ui')

  // Don't show anything if loading or error
  if (loading || error) {
    return null
  }

  // Separate primary and secondary tags
  const primaryTag = tags.find((tag) => tag.primary)
  const secondaryTags = tags.filter((tag) => !tag.primary)

  const handleContainerClick = () => {
    if (tags.length > 0) {
      onEditClick()
    }
  }

  return (
    <PropertyTagsContainer>
      {tags.length === 0 ? (
        <EmptyStateContainer>
          <AddTagButton onClick={onEditClick}>
            <PlusIcon viewBox="0 0 24 24">
              <path
                d="M12 5v14M5 12h14"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </PlusIcon>
            {t('tags.addTags')}
          </AddTagButton>
        </EmptyStateContainer>
      ) : (
        <TagsWrapper onClick={handleContainerClick}>
          {primaryTag && (
            <PropertyTag
              key={primaryTag.id}
              $color={primaryTag.tag?.color}
              $isPrimary
            >
              {primaryTag.tag?.value}
              <PrimaryIndicator>★</PrimaryIndicator>
            </PropertyTag>
          )}
          {secondaryTags.map((tag) => (
            <PropertyTag key={tag?.id} $color={tag?.tag?.color}>
              {tag?.tag?.value}
            </PropertyTag>
          ))}
        </TagsWrapper>
      )}
    </PropertyTagsContainer>
  )
}
